import React from 'react';

import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { Link } from '@firehydrant/design-system';
import PropTypes from 'prop-types';

import OrgRouteLink from 'components/common/OrgRouteLink';
import Prerequisite from 'components/runbooksV2/components/formComponents/Prerequisite';

const PreviewPanel = ({ action }) => {
  const { integration, name, description, config, prerequisites } = action;
  const FHIntegration = integration.slug === 'patchy';
  return (
    <Box width={'75%'} m={5} mb={6}>
      <Flex alignItems="center">
        <img height="20px" src={integration.logo.logo_url} />
        <Text fontSize={3} ml={2} mb={1}>
          {name}
        </Text>
      </Flex>
      <Text fontSize={4} mt={6}>
        Description
      </Text>
      <Text mr={8}>{description}</Text>
      {(!FHIntegration || !!prerequisites?.length) && (
        <>
          <Text fontSize={4} mt={4}>
            Prerequisites
          </Text>
          {!FHIntegration && (
            <Text>
              {integration.enabled ? (
                <CheckIcon color="green" mr={2} mb={1} />
              ) : (
                <CloseIcon color="red" mr={2} mb={1} boxSize={4} />
              )}
              {integration.name === 'nunc'
                ? 'FireHydrant Status Page'
                : action.integration.name}{' '}
              Integration {integration.enabled ? 'installed' : 'not installed '}
              {!integration.enabled && (
                <Link
                  as={OrgRouteLink}
                  to={`/settings/integrations/${integration.slug}`}
                  target="_blank"
                >
                  <Button variant="ghost" mb={1}>
                    Install now
                  </Button>
                </Link>
              )}
            </Text>
          )}
          {prerequisites?.map((prereq) => (
            <Prerequisite
              key={prereq.slug}
              prereq={prereq}
              integration={integration}
            />
          ))}
        </>
      )}
      <Link
        isExternal
        rel="noopener noreferrer"
        href={config.documentation_url}
        color="blue.500"
      >
        Learn more
      </Link>
    </Box>
  );
};

PreviewPanel.propTypes = {
  action: PropTypes.shape({
    description: PropTypes.string,
    integration: PropTypes.shape({
      enabled: PropTypes.bool,
      logo: PropTypes.shape({
        logo_url: PropTypes.string,
      }),
      name: PropTypes.string,
      setup_url: PropTypes.string,
      slug: PropTypes.string,
    }),
    name: PropTypes.string,
    config: PropTypes.shape({
      documentation_url: PropTypes.string,
    }),
  }),
};

export default PreviewPanel;
